/**
 * Flexible Content
 */
const $ = window.jQuery;

export class FlexibleContent {
  // Load
  constructor() {
    this.productBoxes();
    this.accordion();
    this.tabs();
    this.gallerySlider();
  }

  // Gallery slider
  gallerySlider() {
    const $slider = $("[data-gallery-slider]");
    if (!$slider.length) return;

    $slider.each(function () {
      $(this).cycle({
        fx: "fade",
        delay: 3000,
        timeout: 999999999,
        speed: 800,
        log: false,
        manualSpeed: 800,
        prev: "> .gallery-slider__prev",
        next: "> .gallery-slider__next",
        slides: "> .gallery-slider__images__item",
      });
    });
  }

  // Tabs
  tabs() {
    const $tabs = $("[data-tabs]");
    if (!$tabs.length) return;

    const $toggle = $("[data-tabs-toggle]");
    const $content = $("[data-tabs-content]");

    // Hide all content initially
    $content.hide();

    // Toggle a row
    $toggle.on("click", (event) => {
      event.preventDefault();

      const $this = $(event.currentTarget);
      const slug = $this.data("tabs-toggle");

      // Close existing
      $content.filter(`[data-tabs-content!="${slug}"]`).hide();
      $toggle.filter(`[data-tabs-toggle!="${slug}"]`).parent(".tabs__nav__li").removeClass("tabs__nav__li--active");

      // Open/close toggled
      $this.parent(".tabs__nav__li").toggleClass("tabs__nav__li--active");
      $(`[data-tabs-content="${slug}"]`).toggle();

      // Update URL
      const url = $(`[data-tabs-content="${slug}"]`).is(":visible") ? `#${slug}` : location.href.substr(0, location.href.indexOf("#"));
      history.pushState(null, null, url);
    });

    // Hash triggered onload
    if (location.hash.includes("#")) {
      const slug = location.hash.substring(1);
      const $active = $(`[data-tabs-toggle="${slug}"]`);
      if ($active.length) {
        $active.trigger("click");
      }
    }

    // Open first tab (fallback)
    else {
      $(`[data-tabs-toggle]:first`).trigger("click");
    }
  }

  // Product boxes
  productBoxes() {
    const $box = $(".product-box");
    if (!$box.length) return;

    const isMobile = $(window).width() < 768;

    $(window).on("load", function () {
      if (isMobile) return;

      // Equalize height
      let tallest = 0;
      $box.filter(":even").each(function () {
        const height = $(this).find(".product-box__inner").height();
        const nextHeight = $(this).next(".product-box").find(".product-box__inner").height();
        const tallest = Math.max(height, nextHeight);
        $(this).find(".product-box__inner").height(tallest);
        $(this).next(".product-box").find(".product-box__inner").height(tallest);
      });
    });

    // Desktop
    if (isMobile) {
      $(".product-box__see-details").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        const $legalDetails = $(this).parent().find(".product-box__legal-details");
        const $label = $(this).find("span");
        const $close = $(this).find("i.ion-android-close");
        const $open = $(this).find("i.ion-ios-arrow-forward");

        $legalDetails.stop(true, true);

        if ($legalDetails.is(":visible")) {
          $legalDetails.fadeOut("slow");
          $label.text("See Details");
          $close.hide();
          $open.css("display", "inline-block");
        } else {
          $legalDetails.fadeIn("slow");
          $label.text("Close Details");
          $close.css("display", "inline-block");
          $open.hide();
        }
      });
    }

    // Desktop
    else {
      $(".product-box__see-details").on("mouseenter", function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().find(".product-box__legal-details").stop(true, true).fadeIn("slow");
      });

      $(".product-box__see-details").on("mouseleave", function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().find(".product-box__legal-details").stop(true, true).fadeOut("slow");
      });
    }
  }

  // Accordion
  accordion() {
    const $accordion = $("[data-accordion]");
    if (!$accordion.length) return;

    const $row = $("[data-accordion-row]");
    const $toggle = $("[data-accordion-toggle]");
    const $content = $(`[data-accordion-content]`);
    const $standard = $(`[data-accordion-type="content"], [data-accordion-type="columns"]`);

    // Short paragraphs
    $standard.find("p").each(function () {
      const characters = $(this).text().length;
      if (characters < 250) {
        $(this).addClass("p--short-length");
      }
    });

    // Hide all content initially
    $content.hide();

    // Open rows based on URL hash
    $(window).on("load", () => {
      if (!location.hash.includes("#")) return;

      const slug = location.hash.substring(1);
      const $active = $(`[data-accordion-toggle="${slug}"]`);
      if (!$active.length) return;

      $active.trigger("click");
    });

    // Toggle a row
    $toggle.on("click", (event) => {
      event.preventDefault();

      const $this = $(event.currentTarget);
      const slug = $this.data("accordion-toggle");

      // Close existing
      $content.filter(`[data-accordion-content!="${slug}"]`).hide();

      // Open/close toggled
      const $toggle = $this.parent(".accordion__toggle");
      const isActive = $toggle.is(`.accordion__toggle--active`);
      const $row = $this.parents(".accordion__row");

      $(`.accordion__toggle--active`).removeClass("accordion__toggle--active");
      $(`.accordion__row--active`).removeClass("accordion__row--active");
      $(`[data-accordion-content="${slug}"]`).toggle();

      if (!isActive) {
        $toggle.addClass("accordion__toggle--active");
        $row.addClass("accordion__row--active");
      }
    });
  }
}
